"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forceCast = void 0;
/** Force cast to the provided type. */
function forceCast(value) {
    return value;
}
exports.forceCast = forceCast;
//# sourceMappingURL=force-cast.js.map